import { render, staticRenderFns } from "./ManutExperienciasProf.vue?vue&type=template&id=607fb466&"
import script from "./ManutExperienciasProf.vue?vue&type=script&lang=js&"
export * from "./ManutExperienciasProf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports